export const alertContent = (text) => {
  const re = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
  const content = re.exec(text)
  return content != null
}
